import { Content, Footer } from 'antd/lib/layout/layout'
import React from 'react'
import { motion } from 'framer-motion'
import { backtoTopFunction } from './BacktoTop'
import { Col, Row } from 'antd'
import { Link } from 'react-router-dom'

const linkedin = require('../img/icon/linkedin.png')
const CustomFooter = () => {
  return (
    <Footer>
      <Content style={{ textAlign: 'right', marginBottom: "12px" }}>
        <a href="#/" onClick={() => backtoTopFunction()}>
          Back To Top
        </a>
      </Content>
      <Content style={{ textAlign: 'center', marginBottom: "24px" }}>

        <motion.div
          whileTap={{ opacity: 0.3 }}
          whileHover={{
            opacity: 0.7,
            transition: { duration: 0.1 },
          }}
        >

          <a
            //with target _blank, it'll open a new tab
            href="https://www.linkedin.com/in/albertsany/"
            target='_blank'
            rel='noreferrer'
          >
            <img alt="img" src={linkedin} className="iconprofile" />
          </a>
        </motion.div>
      </Content>
      <Content className='footerCaption'>
        <Row className='footerRow'>
          ALBERT SANY ©2025
        </Row>
        <Row className='footerRow' gutter={[24,24]}>
          <Col><Link href="#/" to="/" className='smalltext' >Web Developer</Link></Col>
          <Col><Link href="#/" to="/video" className='smalltext' onClick={()=>backtoTopFunction()}>Videography</Link></Col>
        </Row>
      </Content>
    </Footer>
  )
}

export default CustomFooter
